var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    d: "M0.512104 12.4874L7.19429 14.9568L9.78071 23.1925C9.9462 23.72 10.5976 23.915 11.03 23.5649L14.7548 20.5584C15.1452 20.2434 15.7014 20.2277 16.1094 20.521L22.8275 25.3503C23.2901 25.6832 23.9454 25.4323 24.0614 24.8789L28.9828 1.43984C29.1094 0.835324 28.5095 0.331017 27.9282 0.553643L0.504274 11.0285C-0.17249 11.2869 -0.166593 12.2356 0.512104 12.4874ZM9.36388 13.6423L22.4234 5.67836C22.6581 5.53565 22.8996 5.84987 22.698 6.03498L11.9201 15.9546C11.5413 16.3037 11.2969 16.771 11.2277 17.2782L10.8606 19.9721C10.812 20.3318 10.3016 20.3675 10.2014 20.0194L8.78939 15.107C8.62767 14.5467 8.86334 13.9482 9.36388 13.6423Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e2bbed6d89b1b248c07a260ec4069db7.svg";
export { ForwardRef as ReactComponent };